import React from 'react';
import GroupedAreaSelector from '../GroupedAreaSelector';

interface Props {
  selectedAreaId: number | null;
  onAreaChange: (areaId: number | null) => void;
}

export default function AreaSelector({ selectedAreaId, onAreaChange }: Props) {
  return (
    <GroupedAreaSelector
      selectedAreaId={selectedAreaId}
      onAreaChange={onAreaChange}
    />
  );
}
